export default __webpack_public_path__ + "static/media/paynes-grey.0b2fa1c6.jpg";